export enum IStampDutyCountry {
    ENG_NI = "ENG_NI",
    SCOT = "SCOT",
    WALES = "WALES",
}

export enum IStampDutyYesNoFirstTimeBuyer {
    YES_FIRST_TIME_BUYER = "YES_FIRST_TIME_BUYER",
    NO_FIRST_TIME_BUYER = "NO_FIRST_TIME_BUYER",
}

export enum IStampDutyYesNoOnlyProperty {
    YES_ONLY_PROPERTY = "YES_ONLY_PROPERTY",
    NO_ONLY_PROPERTY = "NO_ONLY_PROPERTY",
}
